import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Ref, Prop, Watch } from 'vue-property-decorator';
import lang from '@blade-sxp/monitor-center/lang/index';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import commonImg from '@blade-sxp/monitor-center/pages/components/carousel/common-img.vue';
let default_1 = class default_1 extends Vue {
    // url = 'https//fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg';
    imgList;
    propData;
    margin = 0;
    carouselBox;
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    number = 0;
    preLength = 0;
    showImg = [];
    time = 0;
    timerNum;
    prevCarousel() {
        this.$refs.carousel && this.$refs.carousel.prev();
    }
    nextCarousel() {
        this.$refs.carousel && this.$refs.carousel.next();
    }
    formChange(imgListArr) {
        this.resetView();
    }
    // 分块展示抓拍图
    showSnapImage() {
        let i = 0;
        let length = this.imgList.length;
        this.showImg = [];
        this.preLength = Math.floor(length / this.number);
        while (i * this.number < length) {
            let index = i * this.number;
            this.showImg.push(this.imgList.slice(index, index + this.number));
            i++;
        }
    }
    mounted() {
        window.onresize = () => {
            return (() => {
                this.resetView();
            })();
        };
    }
    resetView() {
        const pictureBoxWidth = this.carouselBox.offsetWidth - 100;
        this.number = parseInt(String(pictureBoxWidth / 130));
        const pictureWidth = this.number * 130;
        this.margin = parseInt(String((pictureBoxWidth - pictureWidth) / this.number / 2)) + 1;
        this.showSnapImage();
    }
    handleSnapRecord(snapImage) {
        const { startTime, endTime, deviceIdArr } = this.propData;
        // this.$router.push({
        //   path: '/businessPortal/snapRecord',
        //   query: {
        //     params: JSON.stringify({ deviceId: this.snapForm.deviceIds, startTime, endTime, image: snapImage.portraitImage }),
        //   },
        // });
        window.open(this.$router.resolve({
            path: '/monitorCenter/snapRecord',
            query: {
                params: JSON.stringify({ deviceId: deviceIdArr, startTime, endTime, image: snapImage.portraitImage }),
            },
        }).href, '_blank');
    }
    mouseEnter() {
        this.$emit('mouseEnterOpen');
        clearInterval(this.timerNum);
        this.timerNum = setInterval(() => {
            this.time++;
            if (this.time === 2) {
                clearInterval(this.timerNum);
                this.$emit('mouseEnterFoldTwo');
                this.time = 0;
            }
        }, 1000);
    }
    mouseLeave() {
        this.time = 0;
        clearInterval(this.timerNum);
        this.$emit('mouseLeaveFold');
    }
};
__decorate([
    Prop()
], default_1.prototype, "imgList", void 0);
__decorate([
    Prop()
], default_1.prototype, "propData", void 0);
__decorate([
    Ref()
], default_1.prototype, "carouselBox", void 0);
__decorate([
    Watch('imgList', { deep: true, immediate: false })
], default_1.prototype, "formChange", null);
default_1 = __decorate([
    Component({
        name: 'MsgAlarm',
        components: {
            BlurPicture,
            'common-img': commonImg,
        },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
